var map = {
	"./Sdg01.vue": [
		"6548",
		"chunk-2d0cfa79"
	],
	"./Sdg02.vue": [
		"8326",
		"chunk-620fb5aa"
	],
	"./Sdg03.vue": [
		"53e9",
		"chunk-4e581dcc"
	],
	"./Sdg04.vue": [
		"53ef",
		"chunk-28227015"
	],
	"./Sdg05.vue": [
		"79a8",
		"chunk-2217ca24"
	],
	"./Sdg06.vue": [
		"f348",
		"chunk-5378a9db"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1d47";
module.exports = webpackAsyncContext;